
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workout",
      function () {
        return require("private-next-pages/workout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workout"])
      });
    }
  